import { render, staticRenderFns } from "./index.vue?vue&type=template&id=77e71f5f&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=77e71f5f&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77e71f5f",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\xc\\integrated-business-and-finance-wechat\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('77e71f5f')) {
      api.createRecord('77e71f5f', component.options)
    } else {
      api.reload('77e71f5f', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=77e71f5f&scoped=true", function () {
      api.rerender('77e71f5f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/payment/index.vue"
export default component.exports